import { ArrowRight, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "./content";

export const AboutMats = () => (
  <section id="om" className="bg-white py-14 md:py-20" data-testid="about-section">
    <div className="mx-auto grid max-w-6xl gap-8 px-4 sm:px-6 md:grid-cols-12 md:items-center md:gap-12">
      <div className="md:col-span-5">
        <div className="mx-auto max-w-md overflow-hidden rounded-3xl bg-[var(--sand)]">
          <img
            src="/assets/uppdrag-mats-2026.jpg"
            alt="Mats Dellsjö arbetar utomhus vid ett trädgårdsuppdrag"
            className="aspect-[4/5] w-full object-cover object-[38%_center]"
            loading="lazy"
            data-testid="mats-portrait"
          />
        </div>
      </div>

      <div className="md:col-span-7">
        <p className="eyebrow">Möt Mats</p>
        <h2 className="mt-3 max-w-2xl text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
          Personlig kontakt från första samtalet
        </h2>
        <p className="mt-5 max-w-2xl leading-relaxed text-[var(--ink-soft)] md:text-lg">
          Dellsjö Städ & Trädgårdsservice är ett personligt företag med utgångspunkt i Södertälje, med fokus på företag, BRF:er och fastighetsägare. Mats Dellsjö är ägare och din huvudsakliga kontakt.
        </p>

        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <a href={PHONE_HREF} className="btn btn-red sm:min-w-[190px]" data-testid="about-call-button">
            <Phone size={18} aria-hidden /> {PHONE_DISPLAY}
          </a>
          <a href="#offert" className="btn btn-outline sm:min-w-[170px]" data-testid="about-quote-button">
            Begär offert <ArrowRight size={18} aria-hidden />
          </a>
        </div>

      </div>
    </div>
  </section>
);
